<div id="bulletin" class="mt-5">
    <div class="container">
        <div class="row bullet bg-light">
            <div class="col-3 col-md-2 bullet-1">
                <h5 class="text-center">Bulletin</h5>
                <span class=""></span>
            </div>
            <div class="col-9 col-md-10 bullet-2">
                <marquee behavior="scroll" direction="left" class="bulletinMarque"></marquee>
            </div>
        </div>
    </div>
</div>

<!-- Regularly and thoroughly clean your hands with an alcohol-based hand rub or wash them with soap and water. -->